/**
 * radio-group.js
 */

import React from 'react';
import { 
  FormControl,
  FormHelperText,
  FormControlLabel,
  RadioGroup as MuiRadioGroup,
  Radio,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import get from 'lodash.get';
import FormSectionTitle from 'components/menu-drawer/form-section-title';


export default function RadioGroup(props) {
  const {
    formContext: formContextProp,
    name,
    rules,
    label,
    options,
    setValueAs,
    focusHandlers,
  } = props;

  const formContextDefault = useFormContext();
  const formContext = formContextProp || formContextDefault;
  const error = get(formContext.formState.errors, name);


  if (!options) return null;

  return (
    <Controller
      control={formContext.control}
      name={name}
      rules={rules}
      render={({ field: { ref, ...inputProps } }) => (
        <FormControl
          component="fieldset"
          error={Boolean(error)}
          ref={ref}
          onFocus={e => {
            if (focusHandlers) {
              focusHandlers.onFocus(e);
            }
          }}
          onBlur={e => {
            if (focusHandlers) {
              focusHandlers.onBlur(e);
            }
          }}
        >

          {/* label */}
          <FormSectionTitle style={{ marginBottom: 8 }}>{label}</FormSectionTitle>

          {/* error message */}
          {Boolean(error) &&
          <FormHelperText style={{ marginTop: 0, marginBottom: 4 }}>
            {error?.message}
          </FormHelperText>}

          {/* radio group */}
          <MuiRadioGroup
            {...inputProps}
            value={inputProps.value?.id || inputProps.value || ''}
            onChange={e => inputProps.onChange(setValueAs ? setValueAs(e.target.value) : e.target.value)}
            style={{ marginTop: -8 }}
          >
            {options.map(option =>
              <FormControlLabel
                key={option.id}
                label={option.name}
                value={option.id}
                control={<Radio color="primary"/>}
                style={{ marginTop: 4, marginBottom: 4 }}
              />)}
          </MuiRadioGroup>
          
        </FormControl>
      )}
    />
  );
}